import React from "react";
import { IonCard, IonBadge, IonCardHeader, IonCardTitle, IonCardContent } from "@ionic/react";

import classNames from "classnames/bind";

import { WishlistButton } from "./WishlistButton";
import { CartButton } from "./CartButton";
import { ProductPrice } from "./ProductPrice";

import "./MainPageProduct.scss";
import styles from "./MainPageProduct.module.scss";
import { Product } from "@core/types";
import { useConfig } from "../../../../../providers/config";
import { checkProductNew } from "../../../../../utils/checkProductNew";
import { Image } from "../../../../../components/Image/Image";
import { useProductCardActions } from "../../../../../providers/useProductActions";
import { useTranslation } from "react-i18next";

interface ProductCartProps {
  product: Product;
  lazyload?: boolean;
}

const cx = classNames.bind(styles);

const MainPageProduct = ({ product, lazyload }: ProductCartProps) => {
  const { showProductDetail } = useProductCardActions();
  const config = useConfig();
  const { t } = useTranslation();
  const isProductNew = checkProductNew(product.dateCreated, config?.newProductDuration!);

  return (
    <div className={cx("skeletonWidth", "product-component", styles.product)}>
      <IonCard
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          showProductDetail(product.id);
        }}
        className={cx(
          "ion-no-margin ion-margin-top animated fadeIn",
          "productCommon__card",
          "cardIrskom",
          styles.cardShadow,
        )}
      >
        {isProductNew && <IonBadge className={cx("new-product-label")}>{t("NEW")}</IonBadge>}
        <Image
          lazyLoad={lazyload}
          draggable={false}
          style={{ maxWidth: "100%", height: "150px" }}
          image={product?.images[0]}
        />

        <IonCardHeader className={cx("cardIrskomHeader")}>
          <IonCardTitle className={cx("cardIrskomHeaderTitle")}>{product.name}</IonCardTitle>
        </IonCardHeader>

        <IonCardContent className={cx("cardIrskomContent")}>
          <ProductPrice product={product} />
          <CartButton product={product} />
        </IonCardContent>
        <WishlistButton product={product} />
      </IonCard>
    </div>
  );
};

MainPageProduct.displayName = "IRSKOM_MainPageProduct";

export default MainPageProduct;
